import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import "./Dashboard.css";
import Content from "./content";

const Dashboard = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => setIsSidebarOpen(open => !open);
  const closeSidebar  = () => setIsSidebarOpen(false);

  return (
    <div className="dashboard-container">
      {isSidebarOpen && (
        <div className="sidebar-overlay" onClick={closeSidebar}></div>
      )}
      <Sidebar
        isOpen={isSidebarOpen}
        onItemClick={closeSidebar}
        onClose={closeSidebar}
      />
      <div className="dashboard-main-content">
        <div className="dashboard-topbar">
          <button
            className="dashboard-hamburger"
            onClick={toggleSidebar}
            aria-label="Toggle menu"
          >
            ☰
          </button>
        </div>
        <Content />
      </div>
    </div>
  );
};

export default Dashboard;
